import React from 'react';
import { Icon, COLORS } from '@livecommerce/design-system';
import { useUpsell } from 'hooks/useUpsell.jsx';

import { styled } from '@linaria/react';

const Wrapper = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(180deg, ${COLORS.yellow_500} 0%, ${COLORS.yellow_400} 100%);
  border-radius: 6px;
`;

const SIZES = {
  default: {
    wrapper: {
      width: 24,
      height: 24,
    },
    icon: {
      width: 18,
      height: 18,
    },
  },
  small: {
    wrapper: {
      width: 18,
      height: 18,
    },
    icon: {
      width: 14,
      height: 14,
    },
  },
};

export default ({ featureName, size = 'default', ...rest }) => {
  const { enabled } = useUpsell({ featureName });

  if (!enabled) return null;
  const sizeObj = SIZES[size] || SIZES.default;
  return (
    <Wrapper {...rest} style={{ ...rest?.style, width: sizeObj.wrapper.width, height: sizeObj.wrapper.height }}>
      <Icon name="crown" color={COLORS.dark_700} width={sizeObj.icon.width} height={sizeObj.icon.height} />
    </Wrapper>
  );
};
